
import { useId, useState } from "react";
import { ChevronDown } from "lucide-react";
import { FeatureCard } from "./FeatureCard";
/* Mobile-only presentation of the platform-capability cards: a tap-to-open list where each row
   expands into the full FeatureCard. Previews mount only while open so collapsed rows don't run
   their animations. */
export function FeatureAccordion({ features }) {
    const [openKey, setOpenKey] = useState(null);
    const baseId = useId();
    return (<ul className="flex flex-col rounded-2xl bg-[#8A5CFF]/[0.05] px-5 backdrop-blur-md">
      {features.map((feature, i) => {
            const open = openKey === feature.key;
            const panelId = `${baseId}-${feature.key}`;
            return (<li key={feature.key} className={i < features.length - 1 ? "border-b border-white/15" : ""}>
            <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenKey(open ? null : feature.key)} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#8A5CFF]/60">
              <span className="font-sans text-lg font-medium leading-snug tracking-tight text-white">
                {feature.title}
              </span>
              <ChevronDown aria-hidden="true" className={`h-5 w-5 shrink-0 text-white/70 transition-transform duration-200 ${open ? "rotate-180" : ""}`}/>
            </button>
            {open && (<div id={panelId} className="pb-5">
                <FeatureCard href={feature.href} title={feature.title} copy={feature.copy} preview={feature.preview} gated={feature.key !== "payments"}/>
              </div>)}
          </li>);
        })}
    </ul>);
}
